var _defs, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 29",
    width: 18,
    height: 29,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 29,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAdCAMAAACQRsywAAAAAXNSR0IB2cksfwAAAPZQTFRF9/f39PT08PDw6enp8/Pz9vb25+fnsLCw39/f7OzswcHBcnJy6+vr9fX1xcXFcHBwfHx87e3t2NjYe3t7U1NTnZ2d7+/v5ubmg4ODTU1NVVVVuLi48fHxn5+fQEBAXV1dzs7Ourq6UVFRQkJCY2Nj4uLizMzMXl5eampq0dHRc3NzREREenp6iYmJSkpKSEhIh4eHnp6eVFRUS0tLkJCQhYWFkpKS1dXVd3d3Q0NDSUlJioqKZGRkRUVFfn5+QUFBbW1t5eXlZWVlTExMX19f09PT3t7eV1dXvb29y8vLa2trUFBQpaWltLS0qqqqlpaW4+Pj8vLyWDHX9AAAAOVJREFUeJytkVlTwkAQhHcxEw43IIdgZBlBCHIoaiAqaowgcggq/P8/4xaVIrN5dh6/6u3p7WHsH4YnjgydgJlMcR2lM8fC0oiRzZ3kdVGhWDota9aVM/u8KikRtRJe1MlCEI3LJrYcslC2r5qIHQkR6vYU6V9DhFI3A0S8vYuMjHtXERyOAEIdSM/eowcS4fFprNDzC/1L5lUh/41mFw03wODdICFgUrMDnFY4g0MQbnofOPvUGuTznL9YSqJiwFdf641WDmP576lHKtzHnvz0BOgycH63sXOoHp1dDIFlxR6GluwPpOkVLChw8+QAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\ttspan { white-space:pre }\r\n\t")), /*#__PURE__*/React.createElement("use", {
    id: "Background",
    style: {
      fillOpacity: 0.8
    },
    href: "#img1",
    x: 0,
    y: 0
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackGray);
export default __webpack_public_path__ + "static/media/backGray.f7673ace24f5d301f60556092e956e9a.svg";
export { ForwardRef as ReactComponent };